a.me = (function(){
	var my = {
		page:function(){
			a.page({tpl:'me',data:{},ready:function(){
				// Select another account
				$('li[data-action="select-account"]').unbind('click').click(function(){
					a.auth.selectAccountWin({
						close:function(){
							location.hash = '/';
						},
						disable_back:false,
						slideFrom:'fromleft',
						ready:function(token){}
					});
				});
				// Sign out
				$('li[data-action="signout"]').unbind('click').click(function(){
					a.auth.signOut();
				});
				// Update app
				$('li[data-action="update"]').click(function(){
					a.loader.fs.create();
					caches.keys().then(function(cacheNames) {
						return Promise.all(
							cacheNames.map(function(cacheName) {
								return caches.delete(cacheName);
							})
						);
					});
					location.hash = '/';
					setTimeout(function(){
						location.reload();
					},200);
				});
			}});
		}
	}
	return my;
}());